<script lang="ts">
	// UI
	import { PhotoIcon } from "@hitit/new_ui/src";
	import DragAndDrop from "@hitit/hub/src/components/DragAndDrop.svelte";
	import ComponentLoading from "@hitit/hub/src/v7/components/common/ComponentLoading.svelte";
	// Utils
	import { api } from "@hitit/hub/src/stores";
	import { putS3File } from "@hitit/api";
	import { delay } from "@hitit/hub/src/v7/utils";

	//Props
	export let imageaddr = "";
	export let newitem = false;
	export let editmode = false;

	//Constants
	//Variables
	let loading = false;
	let mouseenter = false;

	//Functions
	async function uploadImage(e: { detail: File }) {
		try {
			loading = true;
			const IMAGE_URL = "HITIT_IMAGE_URL";
			const file = e.detail;
			const extMatch = file.name.match(/\.([^\.]+)$/);
			if (!extMatch) throw new Error("format not match");
			const fileUploadResponse = await $api.getFileUploadUrl({
				fileName: file.name.replace(/\.([^\.]+)$/, ".png"),
				fileType: "PNG",
				objectPurpose: "PUBLIC_ARTICLE",
			});
			const { url, id } = fileUploadResponse.data;

			await putS3File(url, file);
			await delay(1000);

			const __id__ = id.split("|")[2];
			const imageURL = IMAGE_URL + __id__;
			imageaddr = imageURL;
		} catch (error) {
			console.log(error);
		} finally {
			loading = false;
		}
	}

	//Do
	$: thumbnailStyle = imageaddr ? `background-image : url(${imageaddr})` : "";
	$: imageaddr ? mouseenter = false : mouseenter = true
</script>

<div class="container">
	<div
		id="thumbnail"
		class="thumbnail"
		class:newitem={newitem}
		style={thumbnailStyle}
	>
		{#if !editmode}
			<div
				class="drop-cover"
				on:dragover={() => {
					mouseenter = true;
				}}
				on:dragleave={() => {
					mouseenter = false;
				}}
				on:mouseleave={() => {
					mouseenter = false;
				}}
				on:mouseenter={() => {
					mouseenter = true;
				}}
				on:touchstart={() => {
					mouseenter = true;
				}}
				on:touchend={() => {
					mouseenter = false;
				}}
			>
				{#if loading}
					<ComponentLoading />
				{:else}
					<DragAndDrop on:file-update={uploadImage}>
						<div class="photoicon">
							<PhotoIcon active={mouseenter} />
						</div>
					</DragAndDrop>
				{/if}
			</div>
		{/if}
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 10px;

		.thumbnail {
			background-size: cover;
			background-repeat: no-repeat;
			background-position: center center;
			width: 200px;
			height: 200px;
			position: relative;
			background-color: #f0f0f4;

			.photoicon {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				width: 60.5px;
				height: 61px;

				&.thumbnailStyle {
					width: 0px;
				}
			}

			.drop-cover {
				background-color: rgba($color: #46474b, $alpha: 0.8);
				width: 100%;
				height: 100%;

				&:hover {
					cursor: pointer;
				}
			}
			&.newitem {
				.drop-cover {
					background-color: rgba($color: #f0f0f4, $alpha: 0.8);
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			flex-direction: row;
			gap: 20px;
		}
	}
</style>
